import privilegeService from '@/services/privilege.service'
import store from '@/store'

// Pages only a franchise principal has a use for. The global guard has already
// loaded the franchise profile by the time a route's beforeEnter runs.
export function franchiseOnlyGuard() {
  if (store.getters.isFranchise) return true
  return privilegeService.getDefaultRoute(store.getters.activePlatform)
}
